/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface GetAllActivitiesResponseDto
 */
export interface GetAllActivitiesResponseDto {
    /**
     * Activity ID
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'deletedAt': string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'name': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'description'?: string;
    /**
     * External source ID for the activity
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'sourceId'?: string;
    /**
     * External source external ID for the activity
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'sourceExternalId'?: string;
    /**
     * Source of the activity
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'source': GetAllActivitiesResponseDtoSourceEnum;
    /**
     * Distance covered in meters
     * @type {number}
     * @memberof GetAllActivitiesResponseDto
     */
    'distance': number;
    /**
     * Duration of activity in seconds
     * @type {number}
     * @memberof GetAllActivitiesResponseDto
     */
    'duration': number;
    /**
     * Type of activity
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'type': GetAllActivitiesResponseDtoTypeEnum;
    /**
     * ActivityDate date in UTC
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'activityDate': string;
    /**
     * User ID who performed the activity
     * @type {string}
     * @memberof GetAllActivitiesResponseDto
     */
    'userId': string;
    /**
     * Array of image URLs associated with this activity
     * @type {Array<string>}
     * @memberof GetAllActivitiesResponseDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Array of participation IDs that this activity was submitted to
     * @type {Array<string>}
     * @memberof GetAllActivitiesResponseDto
     */
    'participationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was approved for
     * @type {Array<string>}
     * @memberof GetAllActivitiesResponseDto
     */
    'approvedParticipationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was declined for
     * @type {Array<string>}
     * @memberof GetAllActivitiesResponseDto
     */
    'declinedParticipationRecords': Array<string>;
    /**
     * User who performed the activity
     * @type {UserDto}
     * @memberof GetAllActivitiesResponseDto
     */
    'user': UserDto;
}

export const GetAllActivitiesResponseDtoSourceEnum = {
    Strava: 'strava',
    Garmin: 'garmin',
    Manual: 'manual',
    AppleHealth: 'apple_health'
} as const;

export type GetAllActivitiesResponseDtoSourceEnum = typeof GetAllActivitiesResponseDtoSourceEnum[keyof typeof GetAllActivitiesResponseDtoSourceEnum];
export const GetAllActivitiesResponseDtoTypeEnum = {
    Run: 'run',
    Bike: 'bike',
    Swim: 'swim'
} as const;

export type GetAllActivitiesResponseDtoTypeEnum = typeof GetAllActivitiesResponseDtoTypeEnum[keyof typeof GetAllActivitiesResponseDtoTypeEnum];


